import { Box, Button, Paper, Typography } from "@mui/material";
import React from "react";
import { PALETTE } from "../styles/theme";
import { WarningAmber } from "@mui/icons-material";
import { Link, Navigate, useLocation } from "react-router-dom";
import { getBasePath, KNOWN_ROUTES } from "../consts";
const NotFoundPage = () => {
    const location = useLocation();
    const basePath = getBasePath(location.pathname);
    if (KNOWN_ROUTES.has(basePath))
        return React.createElement(Navigate, { to: "/" });
    return (React.createElement(Box, { sx: {
            alignItems: "center",
            alignContent: "center",
            height: "100%",
            p: 2,
        } },
        React.createElement(Box, { sx: {
                display: "flex",
                flexDirection: "column",
                gap: 3,
                alignItems: "center",
            } },
            React.createElement(Paper, { sx: {
                    backgroundColor: PALETTE.primary.main,
                    p: 3,
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    gap: 1,
                    color: PALETTE.primary.contrastText,
                    mb: "25%",
                }, elevation: 1 },
                React.createElement(Box, { sx: { display: "flex", gap: 1 } },
                    React.createElement(WarningAmber, { color: "warning" }),
                    React.createElement(Typography, { fontWeight: 500 }, "404")),
                React.createElement(Typography, { fontWeight: 500 }, "Page not found"),
                React.createElement(Button, { component: Link, to: "/", color: "warning", variant: "contained", size: "small", sx: { mt: 1 } }, "Home")))));
};
export default NotFoundPage;
